import { getRetriableErrors } from "../../modules/common/selectors";
import mapActionTypeToActionCreator from "./mapActionTypeToActionCreator";
import { clearErrors } from "../../modules/common/actions/clearErrors";

export const retryErroredActions = () => (dispatch, getState) => {
  const errors = getRetriableErrors(getState());

  dispatch(clearErrors());

  errors.forEach(error => {
    mapActionTypeToActionCreator(dispatch, error);
  });
};
